module.exports = __webpack_public_path__ + "assets/img/1_1685_big.d5919953.jpg";